// extracted by mini-css-extract-plugin
export default {"root":"HostDeliveryModal_root__ZlzBu","modalIcon":"HostDeliveryModal_modalIcon__CVt5m","modalContent":"HostDeliveryModal_modalContent__7s7mA"};